import { User } from "../../models/User";
import DocumentList from "../genericcrud/DocumentList";
const UserMaster = () => {
  return (
    <>{<DocumentList documentMeta={User} />}</>
  );
};

export default UserMaster;
